import { gql } from '@apollo/client'

export const QUERY = gql`
  query FormSelectCourseHomework {
    courseHomeworks(perPage: 1000) {
      nodes {
        id
        title
      }
    }
  }
`
